import { render, staticRenderFns } from "./vueNewCard.vue?vue&type=template&id=4f13f057&scoped=true"
import script from "./vueNewCard.vue?vue&type=script&lang=js"
export * from "./vueNewCard.vue?vue&type=script&lang=js"
import style0 from "./vueNewCard.vue?vue&type=style&index=0&id=4f13f057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f13f057",
  null
  
)

export default component.exports